import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Skull } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(name, email, password);
      nav("/subscribe");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 justify-center mb-8">
          <Skull className="text-primary" size={32} />
          <span className="font-display text-2xl font-bold tracking-tight">FUCK THE OPS</span>
        </Link>
        <div className="bg-card border-2 border-border p-8 block-shadow">
          <h1 className="font-display text-3xl font-bold mb-2">SIGN UP</h1>
          <p className="text-sm text-muted-foreground mb-6">Join free. Preview 25s of anything. Go premium anytime.</p>
          {error && <div data-testid="register-error" className="bg-primary/10 border border-primary text-primary text-sm p-3 mb-4">{error}</div>}
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="overline text-xs text-muted-foreground mb-1 block">Name</label>
              <Input data-testid="register-name" value={name} onChange={(e) => setName(e.target.value)} required className="h-12 bg-transparent border-2 border-border focus:border-primary rounded-none text-white" />
            </div>
            <div>
              <label className="overline text-xs text-muted-foreground mb-1 block">Email</label>
              <Input data-testid="register-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="h-12 bg-transparent border-2 border-border focus:border-primary rounded-none text-white" />
            </div>
            <div>
              <label className="overline text-xs text-muted-foreground mb-1 block">Password</label>
              <Input data-testid="register-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} className="h-12 bg-transparent border-2 border-border focus:border-primary rounded-none text-white" />
            </div>
            <Button data-testid="register-submit" type="submit" disabled={loading} className="w-full h-12 bg-primary hover:bg-white hover:text-primary rounded-none font-bold overline">
              {loading ? "..." : "Create Account"}
            </Button>
          </form>
          <p className="text-sm text-muted-foreground mt-6 text-center">
            Got an account? <Link data-testid="to-login" to="/login" className="text-primary hover:underline">Log in</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
